var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuRecent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/action/query_builder_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/query_builder_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.987 2.50006C8.08701 2.50006 2.49951 8.10006 2.49951 15.0001C2.49951 21.9001 8.08701 27.5001 14.987 27.5001C21.8995 27.5001 27.4995 21.9001 27.4995 15.0001C27.4995 8.10006 21.8995 2.50006 14.987 2.50006ZM14.999 25.0001C9.47398 25.0001 4.99898 20.5251 4.99898 15.0001C4.99898 9.47513 9.47398 5.00013 14.999 5.00013C20.524 5.00013 24.999 9.47513 24.999 15.0001C24.999 20.5251 20.524 25.0001 14.999 25.0001ZM14.6495 8.75013H14.7245C15.2245 8.75013 15.6245 9.15013 15.6245 9.65013V15.3251L20.462 18.2001C20.8995 18.4501 21.037 19.0126 20.7745 19.4376C20.5245 19.8626 19.9745 19.9876 19.5495 19.7376L14.362 16.6251C13.9745 16.4001 13.7495 15.9876 13.7495 15.5501V9.65013C13.7495 9.15013 14.1495 8.75013 14.6495 8.75013Z",
    fill: "#D1D1D7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuRecent);
export default __webpack_public_path__ + "static/media/ic_menu_recent.1f19c365.svg";
export { ForwardRef as ReactComponent };